import { Trans } from '@lingui/react'
import { useEffect } from 'react'
import * as React from 'react'

import { type CartControllerMessageV2 } from 'types/api/cart'
import Notification, {
  NOTIFICATION_TYPES,
} from 'views/components/molecules/Notification'
import scrollToTop from 'views/utils/scrollToTop'

interface NotificationOutOfStockProps {
  messages: CartControllerMessageV2[]
}

const NotificationOutOfStock: React.FunctionComponent<
  NotificationOutOfStockProps
> = ({ messages }): React.ReactElement => {
  useEffect(() => scrollToTop('smooth'), [])

  const productNameList: string[] = messages.map(message => {
    return message.messages[1]
  })

  const label = (
    <>
      <Trans id="cart.notification.outOfStock" />
      {productNameList.length > 0 && (
        <ul>
          {productNameList.map(productName => (
            <li>{productName}</li>
          ))}
        </ul>
      )}
    </>
  )
  return (
    <div className="l-content a-full-width u-padding-large--left u-padding-large--right">
      <Notification
        label={label}
        type={NOTIFICATION_TYPES.INFO}
        className="u-margin--top"
      />
    </div>
  )
}

export { NotificationOutOfStock }
